import { css } from 'styled-components';
export var hideScrollbar = css(["::-webkit-scrollbar{display:none;}"]);